import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, Spinner } from 'reactstrap';
import DuplicateModal from '../../../Components/Common/DuplicateModal';
import { createSelector } from "reselect";
import { setDuplicateCampaignLoader, toggleDuplicateAllModal } from "../../../slices/modals/reducer";
import { duplicateAllItems, duplicateItem, duplicateManyCampaign } from "../../../slices/folder/thunk";
import { getCampaigns } from "../../../slices/campaigns/thunk";
import CustomSelect from "../../../Components/Common/CustomSelect";
import { value } from "jsonpath";
import CustomSelectWithSearch from "../../../Components/Common/CustomSelectWithSearch";
import country from "../../../common/country";

function DuplicateAllModal() {
  const dispatch = useDispatch();
  // Select Modal State
  const selectStates = createSelector(state => state, state => ({
    modalState: state.Modal.duplicateAllModal,
    loaderState: state.Modal.duplicateCampaignLoader,
    menuData: state.MenuData.client,
    clientPath: state.MenuData.clientPath,
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    selectedItems: state.Folder.selectedItems
  }));
  const { modalState, loaderState, menuData, clientPath, brandPath, marketPath, selectedItems } = useSelector(selectStates);

  const [toOpt, setToOpt] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState({});

  async function duplicate() {
    dispatch(setDuplicateCampaignLoader(true));
    await dispatch(duplicateManyCampaign({ campaigns: [...selectedItems], marketId: selectedMarket.value, marketIcon: selectedMarket.marketIcon }));
    // await dispatch(getCampaigns());
    dispatch(toggleDuplicateAllModal());
    dispatch(setDuplicateCampaignLoader(false));
  }

  useEffect(() => {
    if (clientPath && brandPath) {
      const foundClient = menuData.clients.find(client => client._id === clientPath);
      const foundBrand = foundClient.brands.find(brand => brand._id === brandPath);
      setToOpt(foundBrand.markets.map(item => {
        return {
          value: item._id,
          name: item.name,
          flagImg: country.find(country => country.name === item.name).flagImg,
          marketIcon: country.find(country => country.name === item.name).short
        }
      }));
    }
  }, [modalState, clientPath, brandPath]);

  return (
    <Modal fade={true} isOpen={modalState} toggle={() => dispatch(toggleDuplicateAllModal())} centered={true} size="md">
      <ModalHeader className="p-3" toggle={() => dispatch(toggleDuplicateAllModal())}>
        Duplicate
      </ModalHeader>
      <ModalBody className="py-3 px-3">
        <div className="mt-2 text-center">
          <lord-icon
            src="https://cdn.lordicon.com/wzwygmng.json"
            trigger="loop"
            colors="primary:#4b38b3,secondary:#08a88a"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>
          <div className="mt-4-2 fs-15">
            {/* <Label className="w-100 text-start" htmlFor="name">Name</Label>
            <Input type="text" placeholder="Enter Name" value={name} name="name" id="name" onChange={handleChange} /> */}
            <Label className="w-100 text-start mt-2">Choose Market</Label>
            <CustomSelectWithSearch placeholder="Select Market" options={toOpt} onChange={(item) => setSelectedMarket(item)} />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="btn w-sm btn-light"
          data-bs-dismiss="modal"
          onClick={() => dispatch(toggleDuplicateAllModal())}
        >
          Close
        </button>
        <button
          type="button"
          className="btn w-sm btn-primary"
          id="duplicate-record"
          onClick={duplicate}
          disabled={loaderState ? true : false}
        >
          Yes, Duplicate It!
          {loaderState ?
            <Spinner size="sm" className='ms-2'> Loading... </Spinner>
            : null}
        </button>
      </ModalFooter>
    </Modal>
  )
};

export default DuplicateAllModal;